export const FLOORPLAN_DISPLAY_TEMPLATES = new Map([
  [3, true],
  [4, true],
  [6, true],
  [7, true],
  [43, true],
  [44, true],
]);
